export default __webpack_public_path__ + "static/media/des-1.78a3d380.jpg";